import DebugButton from './DebugButton';

export default DebugButton;
